import { type AxiosError, isAxiosError } from 'axios'

import { HTTP_STATUS } from '@/constants'
import { API_ENDPOINTS } from '@/constants/apiEndpoints'

type ApiErrorData = {
    errorCode?: unknown
    [key: string]: unknown
}

export function shouldIgnoreSentryAxiosError(error: unknown): boolean {
    if (!isAxiosError<ApiErrorData>(error)) {
        return false
    }

    const status = error.response?.status
    const data = error.response?.data
    const hasKnownErrorCode = status === HTTP_STATUS.BAD_REQUEST && Boolean(data?.errorCode)

    if (status === HTTP_STATUS.UNAUTHORIZED || status === HTTP_STATUS.FORBIDDEN || hasKnownErrorCode) {
        return true
    }

    const requestUrl = error.config?.url || ''

    if (requestUrl === API_ENDPOINTS.USERS.TOKEN) {
        return true
    }

    return false
}

export type { ApiErrorData }
